module.exports = __webpack_public_path__ + "media/src/images/zero_states/save_feature-5ff108d19d50e0d993fea3326495ff95.png";